import { ProductTypes } from '../../products/product-types';

export const PRODUCTS_TYPE = {
  [ProductTypes.GOODS]: 'APP.PRODUCT',
  [ProductTypes.SERVICES]: 'APP.SERVICE',
  [ProductTypes.DIGITAL]: 'APP.DIGITAL_PRODUCT',
  [ProductTypes.BUNDLE]: 'BUNDLES.BUNDLE',
  arbitrary: 'POSITIONS.USER_DEFINED_POSITION'
};
